import { forwardRef, type Ref, type SVGProps } from "react";

function SvgRebrandSearchColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        fill="#210E10"
        d="M3.3 11a8 8 0 1 1 14.32 4.906L21.714 20 20.3 21.414l-4.095-4.094A8 8 0 0 1 3.3 11"
      />
      <circle cx={11.3} cy={11} r={6} fill="#ECE7DC" />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRebrandSearchColored);
export default ForwardRef;
